import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-view-job',
  templateUrl: './view-job.component.html',
  styleUrls: ['./view-job.component.scss'],
})
export class ViewJobComponent implements OnInit {
  data: any;

  constructor(private config: DynamicDialogConfig) {}

  ngOnInit(): void {
    this.data = this.config.data;
    // console.log('data', this.data);
  }
}
